/**
 * @fileoverview Bank Tier derivation.
 * @description Every spec ("Bank Tier is not manually selected... automatically derived from
 * configured branch-count ranges") requires the commercial tier to come from branch count, never
 * from a form field. The thresholds below are a placeholder demo configuration — the specs
 * themselves never state the real ranges ("configured branch-count ranges" is left to a business
 * decision) — so this function is the one place to update once that configuration is confirmed.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import type { BankTier } from '@/features/sales/types/tenant.types'

/** Placeholder branch-count thresholds pending the real business configuration (see file header). */
const TIER_1_MIN_BRANCHES = 15
const TIER_2_MIN_BRANCHES = 8

/**
 * @description Derives a tenant's commercial tier from its branch count.
 * @param {number} branches - The tenant's captured branch count.
 * @returns {BankTier} 'Tier 1' at TIER_1_MIN_BRANCHES+ branches, 'Tier 2' at TIER_2_MIN_BRANCHES+,
 * otherwise 'Tier 3'.
 */
export function tierFromBranches(branches: number): BankTier {
  if (branches >= TIER_1_MIN_BRANCHES) {
    return 'Tier 1'
  }
  if (branches >= TIER_2_MIN_BRANCHES) {
    return 'Tier 2'
  }
  return 'Tier 3'
}
